const USER_RIGHT_VIEW: string = 'view';
const USER_RIGHT_INSERT: string = 'insert';
const USER_RIGHT_UPDATE: string = 'update';
const USER_RIGHT_DELETE: string = 'delete';
const USER_RIGHT_INPUT_DATE: string = 'inputDate';
const USER_RIGHT_AMEND_DATE: string = 'amendDate';
const USER_RIGHT_INPUT_FEE: string = 'inputFee';
const USER_RIGHT_AMEND_FEE: string = 'amendFee';
const USER_RIGHT_INSPECT: string = 'inspect';
const USER_RIGHT_SET: string = 'set';
const USER_RIGHT_EXPORT: string = 'export';

const TIP_MESSAGE_NO_RIGHT_VIEW: string = '没有权限查看; ';
const TIP_MESSAGE_NO_RIGHT_INSERT: string = '没有权限新增; ';
const TIP_MESSAGE_NO_RIGHT_UPDATE: string = '没有权限更新; ';
const TIP_MESSAGE_NO_RIGHT_DELETE: string = '没有权限删除; ';
const TIP_MESSAGE_NO_RIGHT_OPERATE: string = '没有权限操作; ';
const TIP_MESSAGE_NO_RIGHT_DATE: string = '没有权限选择日期和时间; ';
const TIP_MESSAGE_NO_RIGHT_FEE: string = '没有权限填写费用; ';
const TIP_MESSAGE_NO_INSPECT: string = '没有权限审核; ';
const TIP_MESSAGE_NO_SET: string = '没有权限设置; ';
const TIP_MESSAGE_NO_EXPORT: string = '没有权限数据导出; ';

const TIP_MESSAGE_SUCCESS_OPERATE: string = '操作成功; ';
const TIP_MESSAGE_SUCCESS_INSERT: string = '新增成功; ';
const TIP_MESSAGE_SUCCESS_UPDATE: string = '更新成功; ';
const TIP_MESSAGE_SUCCESS_DELETE: string = '删除成功; ';

const TIP_MESSAGE_GET_DATA_FAILED: string = '获取数据失败; ';
const TIP_MESSAGE_GET_DATA_IS_NULL: string = '获取数据为空; ';

const MESSAGE_BOX_OPERATION_FAILED: string = '操作失败; ';
const MESSAGE_BOX_SELECT_ORDER: string = '请选择托单; ';
const MESSAGE_BOX_SELECT_DATA: string = '请选择数据; ';

const TIP_MESSAGE_DATA_IS_INSPECT: string = '信息已审核; ';
const TIP_MESSAGE_DATA_IS_DELETE: string = '信息已删除; ';
const TIP_MESSAGE_DATA_IS_ACCOUNTING: string = '费用已对帐; ';

const TIP_MESSAGE_COPY_IS_SUCCESS:string='复制成功;';

export default {
    USER_RIGHT_VIEW,
    USER_RIGHT_INSERT,
    USER_RIGHT_UPDATE,
    USER_RIGHT_DELETE,
    USER_RIGHT_INPUT_DATE,
    USER_RIGHT_AMEND_DATE,
    USER_RIGHT_INPUT_FEE,
    USER_RIGHT_AMEND_FEE,
    USER_RIGHT_INSPECT,
    USER_RIGHT_SET,
    USER_RIGHT_EXPORT,

    TIP_MESSAGE_NO_RIGHT_VIEW,
    TIP_MESSAGE_NO_RIGHT_INSERT,
    TIP_MESSAGE_NO_RIGHT_UPDATE,
    TIP_MESSAGE_NO_RIGHT_DELETE,
    TIP_MESSAGE_NO_RIGHT_OPERATE,
    TIP_MESSAGE_NO_RIGHT_DATE,
    TIP_MESSAGE_NO_RIGHT_FEE,
    TIP_MESSAGE_NO_INSPECT,
    TIP_MESSAGE_NO_SET,
    TIP_MESSAGE_NO_EXPORT,

    TIP_MESSAGE_SUCCESS_OPERATE,
    TIP_MESSAGE_SUCCESS_INSERT,
    TIP_MESSAGE_SUCCESS_UPDATE,
    TIP_MESSAGE_SUCCESS_DELETE,

    TIP_MESSAGE_GET_DATA_FAILED,
    TIP_MESSAGE_GET_DATA_IS_NULL,

    MESSAGE_BOX_OPERATION_FAILED,
    MESSAGE_BOX_SELECT_ORDER,
    MESSAGE_BOX_SELECT_DATA,

    TIP_MESSAGE_DATA_IS_INSPECT,
    TIP_MESSAGE_DATA_IS_DELETE,
    TIP_MESSAGE_DATA_IS_ACCOUNTING,

    TIP_MESSAGE_COPY_IS_SUCCESS
}